import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-black pt-[90px]">
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'linear-gradient(rgba(168, 144, 120, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(168, 144, 120, 0.3) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      <div className="max-w-[1600px] mx-auto px-8 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left Content */}
          <div className="space-y-10">
            {/* Main Headline */}
            <div className="space-y-4">
              <h2 className="text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-[1.1] tracking-tight">
                Enterprise Consulting
              </h2>
              <h2 className="text-5xl lg:text-6xl xl:text-7xl font-light text-white leading-[1.1] tracking-tight">
                That Transforms
              </h2>
              <h2 
                className="text-5xl lg:text-6xl xl:text-7xl font-semibold leading-[1.1] tracking-tight"
                style={{
                  background: 'linear-gradient(90deg, #7A6A5A 0%, #A89078 20%, #C4B8A8 40%, #D8CCC0 50%, #C4B8A8 60%, #A89078 80%, #7A6A5A 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                Operations & Growth
              </h2>
            </div>

            {/* Value Proposition */}
            <p className="text-xl text-gray-300 leading-relaxed max-w-xl">
              MACGOC delivers strategic advisory and operational excellence across technology, healthcare, logistics, fuel retail, and finance—empowering enterprises to optimize performance, navigate complexity, and achieve sustainable growth.
            </p>

            {/* Subheading */}
            <p className="text-base text-gray-500 leading-relaxed max-w-xl">
              Operating through U.S.-registered entities, we provide enterprise-grade consulting services to healthcare systems, logistics operators, fuel retailers, investors, and government-adjacent clients nationwide.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap items-center gap-5 pt-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-white px-10 py-4 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
                style={{
                  background: 'linear-gradient(135deg, #7A6A5A 0%, #A89078 50%, #C4B8A8 100%)',
                }}
              >
                Request Consultation
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/services"
                className="inline-flex items-center gap-2 text-gray-300 hover:text-white px-10 py-4 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer border border-gray-800 rounded-full hover:border-gray-700"
              >
                Explore Services
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>

          {/* Right Visual Zone */}
          <div className="relative">
            {/* Main Image */}
            <div className="relative w-full h-[580px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/092fd80d38018975f5bb93fbebedcc0a.jpg"
                alt="Corporate headquarters"
                className="w-full h-full object-cover object-top"
              />
              {/* Metallic Overlay */}
              <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent"></div>
              
              {/* Floating Label */}
              <div className="absolute bottom-8 left-8 right-8">
                <div className="bg-black/70 backdrop-blur-sm rounded-xl p-6 border border-copper/20">
                  <p className="text-xs uppercase tracking-widest text-copper-light mb-2">Operating Through</p>
                  <p className="text-white font-medium">MACAR Enterprises Corp.</p>
                  <p className="text-gray-400 text-sm">North American Division of MACGOC</p>
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div 
              className="absolute -top-4 -right-4 w-32 h-32 rounded-full opacity-20"
              style={{
                background: 'radial-gradient(circle, rgba(168, 144, 120, 0.4) 0%, transparent 70%)',
              }}
            ></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-600">
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-copper/50 to-transparent"></div>
      </div>
    </section>
  );
};

export default HeroSection;
